// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimelineControlHelper  {
    _originalTypeClassName = "Loom.BO.TimelineControlHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimelineControlHelper.translate = translateService;
}
this.TimelineControlHelperKey = null;
this._key = this.TimelineControlHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _TimelineControlHelperKey:any;
get TimelineControlHelperKey(): any {
    return this._TimelineControlHelperKey;
  }
set TimelineControlHelperKey(value: any) {
    this._TimelineControlHelperKey = value;
    this._key = value;
  }

static GetProjectMonthNumbers(project: any): any{let timelineProjectMonths = [];
let currentDate = project?.StartDate;
let projectDuration = Domain.Project.DurationInMonths(project);
for (var i = 1; CLMS.Framework.Number.LessThanOrEqual(() => i, () => projectDuration); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let timelineProjectMonth = new Domain.TimelineProjectMonth();timelineProjectMonth.year = moment(currentDate).year();timelineProjectMonth.month = (moment(currentDate).month() + 1);timelineProjectMonth.projectMonth = Domain.Project.GetProjectMonthByDate(project, currentDate);timelineProjectMonths?.add(timelineProjectMonth);currentDate = (moment(currentDate).add(1, "M")).toDate();}

return timelineProjectMonths;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TimelineControlHelperKey == null || $this.TimelineControlHelperKey == 0;
            }


}